module.exports = __webpack_public_path__ + "static/media/no-time-tracking.8df43df3.svg";